// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "工程造价管理",
      "tec": "刘龙",
      "week": "4,6,8,10,12周",
      "add": "教学楼D座317文法"
    },
    {
      "sub": "建筑电气与设备",
      "tec": "王建宇李凡崔洁",
      "week": "3-13周",
      "add": "教学楼D座326文法"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "工程建设监理",
      "tec": "姚远",
      "week": "3-13周",
      "add": "教学楼D座317文法"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "工程造价管理",
      "tec": "刘龙",
      "week": "3-13周",
      "add": "教学楼D座321文法"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "建筑电气与设备",
      "tec": "王建宇",
      "week": "4,6,8,10,12周",
      "add": "教学楼D座315文法"
    },
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "工程建设监理",
      "tec": "姚远",
      "week": "4,6,8,10,12周",
      "add": "教学楼D座317文法"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
